<template>
  <header>
    <nav
      id="app-header"
      class="navbar"
      role="navigation"
      aria-label="Main navigation"
    >
      <a
        href="#skip-to-main-content"
        class="skip-link t--white t--uppercase t--bold t--caption"
        @click.prevent="focusMainContent"
      >
        Skip to main content
      </a>

      <div class="navbar-container">
        <div class="navbar-brand">
          <div>
            <a
              href="/"
              class="navbar-title navbar-item is-5 t--title-secondary"
              :title="accountName"
            >
              {{ accountName }}
            </a>
            <!--            TODO: when vite migration will be finished we should replace inline svg with this-->
            <!--            <NameAndBadge id="nr-name-and-badge" />-->
            <svg
              width="105"
              height="15"
              viewBox="0 0 105 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.76379 2.53232H6.13814C5.5325 2.52297 4.93102 2.6326 4.36872 2.85483C3.80643 3.07706 3.29456 3.40745 2.86291 3.82676C2.43127 4.24607 2.08847 4.74592 1.85449 5.29721C1.6205 5.8485 1.5 6.44021 1.5 7.0379C1.5 7.63558 1.6205 8.22729 1.85449 8.77858C2.08847 9.32987 2.43127 9.82973 2.86291 10.249C3.29456 10.6683 3.80643 10.9987 4.36872 11.221C4.93102 11.4432 5.5325 11.5528 6.13814 11.5435H9.7582C9.87255 11.5435 9.98229 11.499 10.0637 11.4198C10.145 11.3405 10.1915 11.2328 10.193 11.12V8.5063C10.1915 8.39764 10.1483 8.29357 10.0722 8.21501C9.99615 8.13645 9.89273 8.08922 9.78279 8.08282H6.13814C5.99618 8.08737 5.85475 8.06371 5.72224 8.01325C5.58973 7.96278 5.46885 7.88655 5.3668 7.78907C5.26475 7.69159 5.1836 7.57486 5.12818 7.44581C5.07277 7.31677 5.04421 7.17805 5.04421 7.0379C5.04421 6.89774 5.07277 6.75902 5.12818 6.62998C5.1836 6.50094 5.26475 6.38421 5.3668 6.28673C5.46885 6.18925 5.58973 6.11301 5.72224 6.06255C5.85475 6.01208 5.99618 5.98842 6.13814 5.99298H9.77832C9.88896 5.98793 9.99347 5.94141 10.0705 5.86291C10.1476 5.78442 10.1914 5.67987 10.193 5.57059V2.9558C10.1915 2.84393 10.1458 2.73705 10.0657 2.65794C9.98549 2.57883 9.87717 2.53375 9.76379 2.53232Z"
                fill="#CC0020"
              />
              <path
                d="M15.998 2.53232H12.4104C12.3005 2.53381 12.1954 2.57625 12.1159 2.65113C12.0365 2.72601 11.9888 2.82777 11.9823 2.93596V5.58934C11.9888 5.69716 12.0362 5.79861 12.1151 5.87343C12.1941 5.94825 12.2987 5.99094 12.4081 5.99298H15.998C16.2796 5.99298 16.5497 6.10336 16.7488 6.29983C16.9479 6.49631 17.0598 6.76279 17.0598 7.04066C17.0598 7.31852 16.9479 7.585 16.7488 7.78148C16.5497 7.97796 16.2796 8.08834 15.998 8.08834H12.4215C12.3108 8.08843 12.2042 8.13025 12.1236 8.20527C12.043 8.28029 11.9944 8.38284 11.9879 8.49197V13.5958C11.9943 13.7029 12.0411 13.8037 12.1191 13.8784C12.1971 13.9532 12.3006 13.9963 12.4093 13.9995H13.0172C13.0611 14.0022 13.1051 13.9948 13.1456 13.978C13.1861 13.9611 13.2221 13.9353 13.2508 13.9024L15.5308 11.5479H15.998C17.1967 11.5294 18.3399 11.0465 19.1809 10.2036C20.0219 9.36065 20.4933 8.2252 20.4933 7.04231C20.4933 5.85942 20.0219 4.72396 19.1809 3.88102C18.3399 3.03807 17.1967 2.55524 15.998 2.53674V2.53232Z"
                fill="#383838"
              />
              <path
                d="M34.8068 1.81818V12H33.6136L28.0653 4.00568H27.9659V12H26.733V1.81818H27.9261L33.4943 9.83239H33.5938V1.81818H34.8068ZM39.6166 12.1591C38.8808 12.1591 38.2461 11.9967 37.7125 11.6719C37.1822 11.3438 36.7728 10.8864 36.4845 10.2997C36.1994 9.70975 36.0569 9.02367 36.0569 8.24148C36.0569 7.45928 36.1994 6.76989 36.4845 6.1733C36.7728 5.57339 37.1739 5.10606 37.6876 4.77131C38.2047 4.43324 38.8079 4.2642 39.4973 4.2642C39.895 4.2642 40.2877 4.33049 40.6755 4.46307C41.0633 4.59564 41.4163 4.81108 41.7345 5.10938C42.0527 5.40436 42.3062 5.79545 42.4951 6.28267C42.6841 6.76989 42.7785 7.36979 42.7785 8.08239V8.57955H36.8922V7.56534H41.5853C41.5853 7.13447 41.4992 6.75 41.3268 6.41193C41.1578 6.07386 40.9158 5.80705 40.601 5.61151C40.2894 5.41596 39.9215 5.31818 39.4973 5.31818C39.0299 5.31818 38.6256 5.43419 38.2842 5.66619C37.9461 5.89489 37.6859 6.19318 37.5037 6.56108C37.3214 6.92898 37.2302 7.32339 37.2302 7.74432V8.42045C37.2302 8.99716 37.3297 9.48603 37.5285 9.88707C37.7307 10.2848 38.0108 10.5881 38.3687 10.7969C38.7267 11.0024 39.1426 11.1051 39.6166 11.1051C39.9248 11.1051 40.2032 11.062 40.4518 10.9759C40.7037 10.8864 40.9208 10.7538 41.1031 10.5781C41.2854 10.3991 41.4262 10.1771 41.5257 9.91193L42.6592 10.2301C42.5399 10.6146 42.3394 10.9527 42.0576 11.2443C41.7759 11.5327 41.4279 11.758 41.0136 11.9205C40.5993 12.0795 40.1336 12.1591 39.6166 12.1591ZM44.5332 4.36364L46.3628 7.4858L48.1923 4.36364H49.5446L47.0787 8.18182L49.5446 12H48.1923L46.3628 9.03693L44.5332 12H43.181L45.6071 8.18182L43.181 4.36364H44.5332ZM53.8398 4.36364V5.35795H49.8824V4.36364H53.8398ZM51.0358 2.53409H52.2091V9.8125C52.2091 10.1439 52.2572 10.3925 52.3533 10.5582C52.4527 10.7206 52.5787 10.83 52.7311 10.8864C52.8869 10.9394 53.051 10.9659 53.2233 10.9659C53.3526 10.9659 53.4587 10.9593 53.5415 10.946C53.6244 10.9295 53.6907 10.9162 53.7404 10.9062L53.979 11.9602C53.8995 11.9901 53.7884 12.0199 53.6459 12.0497C53.5034 12.0829 53.3228 12.0994 53.104 12.0994C52.7726 12.0994 52.4478 12.0282 52.1296 11.8857C51.8147 11.7431 51.5529 11.526 51.3441 11.2344C51.1386 10.9427 51.0358 10.5748 51.0358 10.1307V2.53409ZM55.2279 12V1.81818H58.6682C59.4637 1.81818 60.1166 1.95407 60.627 2.22585C61.1374 2.49432 61.5153 2.86387 61.7605 3.33452C62.0058 3.80516 62.1284 4.34044 62.1284 4.94034C62.1284 5.54025 62.0058 6.07221 61.7605 6.53622C61.5153 7.00024 61.1391 7.36482 60.632 7.62997C60.1249 7.89181 59.4769 8.02273 58.6881 8.02273H55.904V6.90909H58.6483C59.1919 6.90909 59.6294 6.82955 59.9608 6.67045C60.2956 6.51136 60.5375 6.28598 60.6867 5.99432C60.8391 5.69934 60.9154 5.34801 60.9154 4.94034C60.9154 4.53267 60.8391 4.17637 60.6867 3.87145C60.5342 3.56652 60.2906 3.3312 59.9559 3.16548C59.6211 2.99645 59.1786 2.91193 58.6284 2.91193H56.4608V12H55.2279ZM60.0205 7.42614L62.5262 12H61.0944L58.6284 7.42614H60.0205ZM66.4435 12.1591C65.7077 12.1591 65.073 11.9967 64.5394 11.6719C64.0091 11.3438 63.5998 10.8864 63.3114 10.2997C63.0264 9.70975 62.8839 9.02367 62.8839 8.24148C62.8839 7.45928 63.0264 6.76989 63.3114 6.1733C63.5998 5.57339 64.0008 5.10606 64.5146 4.77131C65.0316 4.43324 65.6348 4.2642 66.3242 4.2642C66.7219 4.2642 67.1147 4.33049 67.5025 4.46307C67.8903 4.59564 68.2433 4.81108 68.5614 5.10938C68.8796 5.40436 69.1332 5.79545 69.3221 6.28267C69.511 6.76989 69.6055 7.36979 69.6055 8.08239V8.57955H63.7191V7.56534H68.4123C68.4123 7.13447 68.3261 6.75 68.1538 6.41193C67.9847 6.07386 67.7428 5.80705 67.4279 5.61151C67.1164 5.41596 66.7485 5.31818 66.3242 5.31818C65.8569 5.31818 65.4525 5.43419 65.1112 5.66619C64.7731 5.89489 64.5129 6.19318 64.3306 6.56108C64.1483 6.92898 64.0572 7.32339 64.0572 7.74432V8.42045C64.0572 8.99716 64.1566 9.48603 64.3555 9.88707C64.5576 10.2848 64.8377 10.5881 65.1957 10.7969C65.5536 11.0024 65.9696 11.1051 66.4435 11.1051C66.7518 11.1051 67.0302 11.062 67.2788 10.9759C67.5307 10.8864 67.7478 10.7538 67.93 10.5781C68.1123 10.3991 68.2532 10.1771 68.3526 9.91193L69.4862 10.2301C69.3668 10.6146 69.1663 10.9527 68.8846 11.2443C68.6029 11.5327 68.2549 11.758 67.8406 11.9205C67.4263 12.0795 66.9606 12.1591 66.4435 12.1591ZM75.9005 14.8636V10.8267H75.8011C75.7149 10.9659 75.5923 11.1416 75.4332 11.3537C75.2741 11.5625 75.047 11.7498 74.7521 11.9155C74.4571 12.0779 74.0643 12.1591 73.5738 12.1591C72.9374 12.1591 72.3756 11.9983 71.8884 11.6768C71.4012 11.352 71.0201 10.8946 70.745 10.3047C70.4699 9.71141 70.3323 9.01042 70.3323 8.2017C70.3323 7.39962 70.4699 6.7036 70.745 6.11364C71.0201 5.52367 71.4029 5.06794 71.8934 4.74645C72.3839 4.42495 72.9507 4.2642 73.5937 4.2642C74.0908 4.2642 74.4836 4.34706 74.7719 4.51278C75.0636 4.67519 75.2857 4.8608 75.4381 5.0696C75.5939 5.27509 75.7149 5.44413 75.8011 5.5767H75.9403V4.36364H77.0738V14.8636H75.9005ZM73.7329 11.1051C74.2035 11.1051 74.6013 10.9825 74.9261 10.7372C75.2509 10.4886 75.4978 10.1456 75.6668 9.7081C75.8359 9.26728 75.9204 8.75852 75.9204 8.18182C75.9204 7.61174 75.8375 7.11293 75.6718 6.68537C75.5061 6.2545 75.2608 5.91974 74.936 5.68111C74.6112 5.43916 74.2102 5.31818 73.7329 5.31818C73.2357 5.31818 72.8214 5.44579 72.49 5.70099C72.1619 5.95289 71.9149 6.29593 71.7492 6.73011C71.5868 7.16098 71.5056 7.64489 71.5056 8.18182C71.5056 8.72538 71.5885 9.21922 71.7542 9.66335C71.9232 10.1042 72.1718 10.4555 72.4999 10.7173C72.8314 10.9759 73.2424 11.1051 73.7329 11.1051ZM83.334 8.87784V4.36364H84.5073V12H83.334V10.7074H83.2545C83.0755 11.0952 82.7971 11.425 82.4192 11.6967C82.0414 11.9652 81.5641 12.0994 80.9874 12.0994C80.5102 12.0994 80.0859 11.995 79.7147 11.7862C79.3435 11.5741 79.0518 11.2559 78.8397 10.8317C78.6276 10.4041 78.5215 9.86553 78.5215 9.21591V4.36364H79.6948V9.13636C79.6948 9.69318 79.8506 10.1373 80.1621 10.4688C80.477 10.8002 80.8781 10.9659 81.3653 10.9659C81.6569 10.9659 81.9536 10.8913 82.2552 10.7422C82.5601 10.593 82.8153 10.3643 83.0208 10.0561C83.2296 9.74787 83.334 9.35511 83.334 8.87784ZM89.158 12.1591C88.4222 12.1591 87.7875 11.9967 87.2539 11.6719C86.7236 11.3438 86.3142 10.8864 86.0259 10.2997C85.7409 9.70975 85.5983 9.02367 85.5983 8.24148C85.5983 7.45928 85.7409 6.76989 86.0259 6.1733C86.3142 5.57339 86.7153 5.10606 87.229 4.77131C87.7461 4.43324 88.3493 4.2642 89.0387 4.2642C89.4364 4.2642 89.8292 4.33049 90.2169 4.46307C90.6047 4.59564 90.9577 4.81108 91.2759 5.10938C91.5941 5.40436 91.8476 5.79545 92.0365 6.28267C92.2255 6.76989 92.3199 7.36979 92.3199 8.08239V8.57955H86.4336V7.56534H91.1267C91.1267 7.13447 91.0406 6.75 90.8682 6.41193C90.6992 6.07386 90.4572 5.80705 90.1424 5.61151C89.8308 5.41596 89.4629 5.31818 89.0387 5.31818C88.5713 5.31818 88.167 5.43419 87.8256 5.66619C87.4875 5.89489 87.2274 6.19318 87.0451 6.56108C86.8628 6.92898 86.7716 7.32339 86.7716 7.74432V8.42045C86.7716 8.99716 86.8711 9.48603 87.0699 9.88707C87.2721 10.2848 87.5522 10.5881 87.9101 10.7969C88.2681 11.0024 88.684 11.1051 89.158 11.1051C89.4662 11.1051 89.7446 11.062 89.9932 10.9759C90.2451 10.8864 90.4622 10.7538 90.6445 10.5781C90.8268 10.3991 90.9677 10.1771 91.0671 9.91193L92.2006 10.2301C92.0813 10.6146 91.8808 10.9527 91.599 11.2443C91.3173 11.5327 90.9693 11.758 90.555 11.9205C90.1407 12.0795 89.675 12.1591 89.158 12.1591ZM98.8138 6.07386L97.7598 6.37216C97.6935 6.1965 97.5958 6.0258 97.4665 5.86009C97.3406 5.69105 97.1682 5.55185 96.9495 5.44247C96.7307 5.3331 96.4506 5.27841 96.1093 5.27841C95.6419 5.27841 95.2525 5.38613 94.9409 5.60156C94.6327 5.81368 94.4786 6.08381 94.4786 6.41193C94.4786 6.7036 94.5846 6.93395 94.7968 7.10298C95.0089 7.27202 95.3403 7.41288 95.7911 7.52557L96.9246 7.80398C97.6074 7.9697 98.1161 8.22325 98.4509 8.56463C98.7856 8.9027 98.953 9.33854 98.953 9.87216C98.953 10.3097 98.8271 10.7008 98.5752 11.0455C98.3266 11.3902 97.9786 11.6619 97.5311 11.8608C97.0837 12.0597 96.5633 12.1591 95.9701 12.1591C95.1912 12.1591 94.5465 11.9901 94.0361 11.652C93.5257 11.3139 93.2025 10.8201 93.0667 10.1705L94.1803 9.89205C94.2863 10.303 94.4869 10.6113 94.7819 10.8168C95.0801 11.0223 95.4696 11.125 95.9502 11.125C96.497 11.125 96.9312 11.009 97.2527 10.777C97.5775 10.5417 97.7399 10.2599 97.7399 9.93182C97.7399 9.66667 97.6471 9.4446 97.4615 9.26562C97.2759 9.08333 96.9909 8.94744 96.6064 8.85795L95.3337 8.55966C94.6344 8.39394 94.1206 8.13707 93.7925 7.78906C93.4677 7.43774 93.3053 6.99858 93.3053 6.47159C93.3053 6.04072 93.4263 5.65956 93.6682 5.32812C93.9135 4.99669 94.2466 4.73651 94.6675 4.54758C95.0917 4.35866 95.5723 4.2642 96.1093 4.2642C96.8649 4.2642 97.4582 4.42992 97.8891 4.76136C98.3233 5.0928 98.6315 5.5303 98.8138 6.07386ZM103.34 4.36364V5.35795H99.3828V4.36364H103.34ZM100.536 2.53409H101.71V9.8125C101.71 10.1439 101.758 10.3925 101.854 10.5582C101.953 10.7206 102.079 10.83 102.232 10.8864C102.387 10.9394 102.551 10.9659 102.724 10.9659C102.853 10.9659 102.959 10.9593 103.042 10.946C103.125 10.9295 103.191 10.9162 103.241 10.9062L103.479 11.9602C103.4 11.9901 103.289 12.0199 103.146 12.0497C103.004 12.0829 102.823 12.0994 102.604 12.0994C102.273 12.0994 101.948 12.0282 101.63 11.8857C101.315 11.7431 101.053 11.526 100.844 11.2344C100.639 10.9427 100.536 10.5748 100.536 10.1307V2.53409Z"
                fill="#383838"
              />
            </svg>
          </div>
          <a
            href="#"
            role="button"
            class="navbar-burger"
            aria-label="menu"
            aria-expanded="false"
            @click.stop="handleToggleMenu"
          >
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </a>
        </div>

        <div class="navbar-menu" ref="menu">
          <div class="navbar-start">
            <ul>
              <li>
                <router-link
                  to="/requests/new"
                  v-slot="{ href, route, navigate }"
                  custom
                >
                  <div :class="getNavbarItemClassName(route)">
                    <a :href="href" @click="handleNavigate($event, navigate)">
                      Make request
                    </a>
                  </div>
                </router-link>
              </li>
              <li>
                <router-link
                  to="/requests"
                  v-slot="{ href, route, navigate }"
                  custom
                >
                  <div :class="getNavbarItemClassName(route)">
                    <a :href="href" @click="handleNavigate($event, navigate)">
                      All requests
                    </a>
                  </div>
                </router-link>
              </li>
              <li>
                <router-link
                  to="/documents"
                  v-slot="{ href, route, navigate }"
                  custom
                >
                  <div :class="getNavbarItemClassName(route)">
                    <a :href="href" @click="handleNavigate($event, navigate)">
                      Documents
                    </a>
                  </div>
                </router-link>
              </li>
              <li>
                <router-link
                  v-if="canReadStaffOnly"
                  to="/tasks"
                  v-slot="{ href, route }"
                  custom
                >
                  <div :class="getNavbarItemClassName(route)">
                    <a :href="href"> All tasks </a>
                  </div>
                </router-link>
              </li>
            </ul>
          </div>

          <div class="navbar-end">
            <template v-if="hasFullTextFeature">
              <GlobalFullTextSearch
                class="navbar-item search-field-on-navbar"
              />
            </template>

            <template v-if="isAuthenticated">
              <template v-if="canManageInternalAdminTools">
                <div
                  class="navbar-item has-dropdown is-hoverable"
                  data-link="nr-internal"
                >
                  <span class="navbar-link">NR Internal</span>
                  <div class="navbar-dropdown is-right is-boxed">
                    <a href="/stats" class="navbar-item">Stats</a>
                    <a href="/internal/accounts" class="navbar-item"
                      >Customers</a
                    >
                    <a href="/internal/users" class="navbar-item">Users</a>
                  </div>
                </div>
              </template>

              <template v-if="canReadAdminOnly">
                <div
                  class="navbar-item has-dropdown is-hoverable"
                  data-link="admin"
                >
                  <span class="navbar-link">Admin</span>
                  <div class="navbar-dropdown is-right is-boxed">
                    <template v-if="canManageAll">
                      <a href="/admin" class="navbar-item">Admin dashboard</a>
                    </template>
                    <template v-if="isSpa">
                      <router-link
                        v-if="canManageAll"
                        to="/admin/document_dashboard"
                        class="navbar-item"
                      >
                        Document dashboard
                      </router-link>
                    </template>
                    <template v-else>
                      <a
                        v-if="canManageAll"
                        href="/admin/document_dashboard"
                        class="navbar-item"
                      >
                        Document dashboard
                      </a>
                    </template>
                    <a href="/reports" class="navbar-item">Reports</a>

                    <hr class="navbar-divider" />
                    <a href="/admin/departments" class="navbar-item"
                      >Departments</a
                    >
                    <a href="/admin/users" class="navbar-item">Users</a>
                    <a href="/admin/request_text_filters" class="navbar-item">
                      Alerts
                    </a>
                    <a href="/admin/tags" class="navbar-item">Tags</a>
                    <a
                      v-if="account.uploaders_feature_flag"
                      href="/admin/onboarding"
                      class="navbar-item"
                    >
                      Upload users
                    </a>

                    <template
                      v-if="account.redaction || account.document_review"
                    >
                      <hr class="navbar-divider" />
                      <a href="/admin/redaction_reasons" class="navbar-item">
                        Redaction reasons
                      </a>
                      <a href="/admin/redaction_regexes" class="navbar-item">
                        Redaction patterns
                      </a>
                    </template>

                    <hr class="navbar-divider" />
                    <a href="/admin/message_templates" class="navbar-item">
                      Message templates
                    </a>
                    <a href="/admin/close_request_types" class="navbar-item">
                      Closure templates
                    </a>
                    <a
                      v-if="account.payments"
                      href="/admin/invoice_templates"
                      class="navbar-item"
                    >
                      Invoice templates
                    </a>
                    <a
                      v-if="account.payments"
                      href="/admin/invoice_charges"
                      class="navbar-item"
                    >
                      Invoice charges
                    </a>

                    <template v-if="canManageAll">
                      <hr class="navbar-divider" />
                      <a :href="accountSettingsPath" class="navbar-item">
                        Portal settings
                      </a>
                    </template>
                  </div>
                </div>
              </template>

              <div
                class="navbar-item has-dropdown is-hoverable"
                data-link="profile"
              >
                <span class="navbar-link">Signed in</span>
                <div class="navbar-dropdown is-right is-boxed">
                  <div class="navbar-item">
                    <p>
                      Signed in as
                      <strong>{{ user.email_or_name }}</strong>
                    </p>
                  </div>
                  <hr class="navbar-divider" />
                  <a
                    v-if="!permissionsPreviewUser"
                    :href="userSettingsPath"
                    class="navbar-item"
                    >My settings</a
                  >
                  <a
                    v-if="canPreviewUser"
                    @click="setPermissionModal"
                    class="navbar-item"
                  >
                    Permission preview
                  </a>

                  <a
                    href="/users/sign_out"
                    class="navbar-item"
                    @click.prevent.stop="handleSignoutClick"
                  >
                    Sign out
                  </a>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="navbar-item">
                <form
                  v-if="hasCivicplusSSOFeature"
                  action="/users/auth/openid_connect"
                  method="post"
                >
                  <input :name="csrfParam" :value="csrfToken" type="hidden" />
                  <input
                    type="Submit"
                    class="button is-primary"
                    value="Sign in"
                  />
                </form>
                <a
                  v-else
                  href="/users/sign_in"
                  class="button is-primary"
                  data-link="sign-in"
                >
                  Sign in
                </a>
              </div>
            </template>
          </div>
        </div>
      </div>
      <template v-if="hasFullTextFeature">
        <GlobalFullTextSearch class="search-field-below-navbar" />
      </template>
      <NrModal
        :class="`permission-modal ${!isSpa ? 'legacy-permission-modal' : ''}`"
        primaryButtonText="Set permissions"
        secondaryButtonText="Cancel"
        title="Set permission view"
        :hasSecondaryButton="true"
        :show="permissionModal"
        @on-primary-click="submitPermission"
        @on-secondary-click="resetPreviewModal"
        @on-close-click="resetPreviewModal"
      >
        <NrSelect
          v-model="selectedPreviewUsers"
          :options="filteredPreviewUsers"
          @open="searchPreviewUsers"
          @search="searchPreviewUsers"
          :filterable="false"
          :loading="previewFetchState.fetching"
          :hasMore="!previewFetchState.end"
          @load-more="loadMorePreviewUsers"
        >
          <template v-slot:label>
            <span>Select a user to impersonate</span>
          </template>
        </NrSelect>

        <p>
          By selecting this user, you can preview what the application looks
          like as this user, including which controls and content they can
          access. You can only select other users who have lower level
          permission roles in the application. Any action taken during the
          preview will still be attributed to your user account.
        </p>
      </NrModal>
    </nav>
    <div v-if="permissionsPreviewUser" class="preview-banner">
      <div class="preview-banner-title">
        <NrTooltip
          :label="`By selecting this user, you can preview what the application looks like as this user, including which controls and content they can access. You can only select other users who have lower level permission roles in the application. Any action taken during the preview will still be attributed to your user account.`"
        >
          <NrIcon
            class="m-right-8 m-left-8 m-bottom-4 inline-icon"
            name="info-circle"
          />
          <span class="has-text-weight-semibold">
            Permission view on: viewing portal as "{{ permissionsPreviewUser }}"
          </span>
        </NrTooltip>
      </div>
      <div class="preview-banner-switch-container">
        <NrButton @click="submitPermission">
          Turn off permissions preview
        </NrButton>
      </div>
    </div>
    <NrModal
      primaryButtonText="Sign in"
      title="Session expired"
      size="small"
      :hasSecondaryButton="false"
      :show="sessionExpired"
      @on-primary-click="directToSignIn"
    >
      <p>
        You have been logged out due to inactivity. Use the button below to sign
        back into the application
      </p>
    </NrModal>
    <!-- This form is submitted programatically to create a POST request -->
    <form
      v-if="hasCivicplusSSOFeature"
      ref="signInForm"
      action="/users/auth/openid_connect"
      method="post"
      class="openid-form"
    >
      <input :name="csrfParam" :value="csrfToken" type="hidden" />
    </form>
    <NrModal
      class="session-warning-modal"
      title="Your session will expire soon"
      type="warning"
      :show="showSessionWarningModal"
      primaryButtonText="Yes, extend my expiration"
      secondaryButtonText="Logout"
      size="small"
      hasSecondaryButton
      @on-primary-click="resetSessionTimeout"
      @on-secondary-click="handleSignoutClick"
      >Your session will expire soon and you will be logged out automatically.
      Do you wish to extend your session? Your session will timeout in
      {{ expirationInMinsAndSecs }}
    </NrModal>
  </header>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { truncate, throttle, uniqBy, isEmpty } from 'lodash'
import { mapActions, mapMutations } from 'vuex'
import GlobalFullTextSearch from './global_full_text_search.vue'
import NrModal from '@nextrequestco/components/src/components/NrModal'
import NrButton from '@nextrequestco/components/src/components/NrButton'
import NrIcon from '@nextrequestco/components/src/components/NrIcon'
import NrTooltip from '@nextrequestco/components/src/components/NrTooltip'
import NrSelect from '@nextrequestco/components/src/components/NrSelect'
import API from '../api.js'
import consumer from '../../utils/action_cable_consumer.js'
import helpers from '../../utils/helpers.js'

const genericUsers = [
  {
    value: 'admin',
    label: 'Generic Admin',
    role: 'admin'
  },
  {
    value: 'publisher',
    label: 'Generic Publisher',
    role: 'publisher'
  },
  {
    value: 'staff',
    label: 'Generic Staff',
    role: 'staff'
  },
  {
    value: 'guest',
    label: 'Generic Requester',
    role: 'guest'
  }
]

type Account = {
  id: number
  name: string
  document_review: boolean // eslint-disable-line camelcase
  payments: boolean
  redaction: boolean
  uploaders_feature_flag: boolean // eslint-disable-line camelcase
  full_text_search_feature_flag: boolean // eslint-disable-line camelcase
  civicplus_sso_feature_flag: boolean // eslint-disable-line camelcase
}

type User = {
  id: number
  email_or_name: string // eslint-disable-line camelcase
}

export default defineComponent({
  name: 'app-header',
  components: {
    GlobalFullTextSearch,
    NrModal,
    NrButton,
    NrIcon,
    NrTooltip,
    NrSelect
  },
  props: {
    account: {
      type: Object as PropType<Account | null>,
      default() {
        return {
          id: -1,
          name: 'NextRequest',
          document_review: false,
          payments: false,
          redaction: false,
          uploaders_feature_flag: false,
          full_text_search_feature_flag: false,
          civicplus_sso_feature_flag: false
        }
      }
    },
    user: {
      type: Object as PropType<User | null>,
      default: null
    },
    canManageInternalAdminTools: {
      type: Boolean,
      default: false
    },
    canReadStaffOnly: {
      type: Boolean,
      default: false
    },
    canManageAll: {
      type: Boolean,
      default: false
    },
    canReadAdminOnly: {
      type: Boolean,
      default: false
    },
    canPreviewUser: {
      type: Boolean,
      default: false
    },
    permissionsPreviewUser: {
      type: String,
      default: null
    },
    requestPrettyId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      isMenuToggled: false,
      permissionModal: false,
      selectedPreviewUsers: [],
      filteredPreviewUsers: [],
      sessionExpired: false,
      previewFetchState: {
        page: 0,
        search_text: '',
        end: false,
        fetching: false
      },
      showSessionWarningModal: false,
      expirationInMinsAndSecs: '',
      csrfToken: null,
      subscription: null
    }
  },

  mounted() {
    this.setUpSessionExpiration()
    this.setCsrfTokenFromPage()
    this.subscribeToUserJobChannel()
  },

  beforeUnmount() {
    this.unsubscribeToUserJobChannel()
  },

  watch: {
    requestPrettyId(newVal, _oldVal) {
      // Catch up job statuses where request pretty id is required
      if (!newVal || !this.user) return
      this.catchUpOnJobStatuses()
    }
  },

  computed: {
    isRapidReview() {
      return this.$route.name === 'rapid-review'
    },

    isSpa(): boolean {
      return !!this.$router.options.routes.length
    },

    accountSettingsPath() {
      return `/admin/accounts/${this.account.id}`
    },

    userSettingsPath() {
      return `/settings?id=${this.user.id}`
    },

    accountName(): string {
      if (this.account) {
        return truncate(this.account.name, { length: 40 })
      } else {
        return 'NextRequest'
      }
    },

    isAuthenticated(): boolean {
      return !!this.user && !!this.account
    },

    hasFullTextFeature(): boolean {
      return this.isAuthenticated && this.account.full_text_search_feature_flag
    },

    selectedPreviewUserId(): number | null {
      return this.selectedPreviewUsers ? this.selectedPreviewUsers.value : null
    },

    hasCivicplusSSOFeature(): boolean {
      return this.account.civicplus_sso_feature_flag
    },

    csrfParam(): string {
      const csrfEl = document.getElementsByName('csrf-param')
      const param =
        csrfEl.length > 0 ? (csrfEl[0] as HTMLMetaElement).content : ``
      return param
    }
  },

  methods: {
    ...mapActions('rapid_review', [
      'fetchZipFileToDownload',
      'fetchFolders',
      'refreshDocumentReviewList',
      'fetchReviewStateCounts',
      'removeProcessingDocIds'
    ]),

    catchUpOnJobStatuses() {
      const processingJobs = helpers.fetchUserProcessingJobIds(
        this.user.id,
        this.requestPrettyId,
        'rapid_review'
      )
      if (processingJobs && processingJobs.length) {
        this.checkJobStatuses(processingJobs)
      }
    },

    unsubscribeToUserJobChannel() {
      if (consumer.connection.isOpen()) {
        consumer.subscriptions.remove(this.subscription)
      }
    },

    checkJobStatuses(processingJobs) {
      API.sidekiqStatuses({ jids: processingJobs }).then((response) => {
        const jobs = response.data.jobs
        if (jobs && jobs.length) {
          jobs.forEach((job) => {
            const pendingJob = helpers.fetchPendingJobById(
              job.jid,
              this.user.id,
              this.requestPrettyId,
              'rapid_review'
            )
            if (!isEmpty(pendingJob)) {
              const data = {
                status: job.status,
                jobType: pendingJob.jobType,
                jobId: job.jid,
                docIds: pendingJob.docIds,
                prettyId: this.requestPrettyId
              }
              this.setupToastMessage(data)
            }
          })
        }
      })
    },

    subscribeToUserJobChannel() {
      if (!this.user) return
      const self = this
      this.subscription = consumer.subscriptions.create(
        // Subscribe to channel
        {
          channel: 'UserJobChannel',
          user_id: this.user.id
        },
        {
          received(data) {
            const jobData = {
              status: data.status,
              jobType: data.job_type,
              jobId: data.job_id,
              docIds: data.doc_ids,
              prettyId: data.pretty_id || self.requestPrettyId,
              payload: data.payload
            }
            self.$store.state.lastJobMessage = jobData
            self.setupToastMessage(jobData)
          }
        }
      )
    },

    setupToastMessage({ status, jobType, jobId, docIds, prettyId, payload }) {
      if (helpers.backgroundJobComplete(status)) {
        if (jobType === 'bulk_download') {
          this.setupBulkDownload(jobId, docIds?.length, prettyId)
        } else {
          this.setSuccessToastMessage(jobType, docIds?.length, payload)
        }
      } else if (helpers.backgroundJobFailed(status)) {
        this.setFailedToastMessage(jobType, docIds?.length, payload)
      }

      if (
        helpers.backgroundJobComplete(status) ||
        helpers.backgroundJobFailed(status)
      ) {
        if (this.isRapidReview) {
          this.fetchFolders(prettyId).then(() => {
            this.refreshDocumentReviewList()
            this.fetchReviewStateCounts(prettyId)
          })
        }
        if (this.$store) {
          this.removeProcessingDocIds(docIds)
        }
        helpers.removePendingJobById(
          jobId,
          this.user.id,
          prettyId,
          'rapid_review'
        )
      }
    },

    completeToastMessage(jobType: string, numberOfDocuments: number): string {
      switch (jobType) {
        case 'zipfile_creator':
          return `Successfully zipped ${numberOfDocuments} document(s).`
        case 'process_folders':
          return `Successfully moved ${numberOfDocuments} document(s).`
        case 'draft_redaction':
          return `Successfully draft redacted ${numberOfDocuments} document(s).`
        case 'zipfile_reader':
          return `Successfully extracted ${numberOfDocuments} document(s).`
        case 'bulk_download':
          return `Downloading zip file containing ${numberOfDocuments} document(s).`
        case 'bulk_delete':
          return `Successfully deleted ${numberOfDocuments} document(s).`
        case 'mail_reader':
          return `Succesfully extracted ${numberOfDocuments} document.`
        case 'flatten':
          return `Successfully flattened ${numberOfDocuments} document(s).`
      }
    },

    failedToastMessage(
      jobType: string,
      numberOfDocuments: number
    ): string | null {
      switch (jobType) {
        case 'zipfile_creator':
          return `${numberOfDocuments} document(s) failed to zip.`
        case 'process_folders':
          return `${numberOfDocuments} document(s) failed to move.`
        case 'draft_redaction':
          return `${numberOfDocuments} document(s) failed to draft redact.`
        case 'zipfile_reader':
          return `${numberOfDocuments} document(s) failed to unzip.`
        case 'bulk_download':
          return `Zip file containing ${numberOfDocuments} document(s) failed to download.`
        case 'bulk_delete':
          return `${numberOfDocuments} document(s) failed to delete.`
        case 'mail_reader':
          return `${numberOfDocuments} document failed to extract.`
        case 'flatten':
          return `${numberOfDocuments} document(s) failed to flatten.`
      }
    },

    setSuccessToastMessage(
      jobType: string,
      numberOfDocuments: number,
      payload: null | { message: string }
    ) {
      const toast =
        payload.message || this.completeToastMessage(jobType, numberOfDocuments)
      if (toast) {
        this.$toasted.success(toast)
      }
    },

    setFailedToastMessage(
      jobType: string,
      numberOfDocuments: number | undefined,
      payload: null | { message: string }
    ) {
      const toast =
        payload.message || this.failedToastMessage(jobType, numberOfDocuments)
      if (toast) {
        this.$toasted.error(toast)
      }
    },

    fetchZipFile(payload, numOfDocs) {
      this.fetchZipFileToDownload(payload)
        .then(() => {
          const message = this.completeToastMessage('bulk_download', numOfDocs)
          this.$toasted.success(message)
        })
        .catch(() => {
          const message = this.failedToastMessage('bulk_download', numOfDocs)
          this.$toasted.error(message)
        })
    },

    setupBulkDownload(jobId, numOfDocs, prettyId) {
      // Since there is no Vuex store available on the app_header.ts instance, we emit an event to prepare the zip file in app_header.ts when on the non Vue app
      const ssJobId = sessionStorage.getItem(`job_${jobId}`)
      if (ssJobId && jobId === ssJobId) {
        const payload = { jid: jobId, request_id: prettyId }
        this.$store
          ? this.fetchZipFile(payload, numOfDocs)
          : this.$emit('fetch-zip-file-to-download', {
              jid: jobId,
              request_id: prettyId,
              numOfDocs
            })

        helpers.clearJobIdFromSessionStorage(jobId)
      }
    },
    setCsrfTokenFromPage() {
      const csrfEl = document.getElementsByName('csrf-token')
      const token =
        csrfEl.length > 0 ? (csrfEl[0] as HTMLMetaElement).content : ``
      this.csrfToken = token
    },
    setCsrfTokenFromApi() {
      API.getCsrfToken().then((response) => {
        this.csrfToken = response.data.csrf_token
      })
    },
    resetSessionTimeout() {
      API.resetSession().then(() => {
        this.showSessionWarningModal = false
      })
    },
    timeToSessionExpiration() {
      let expirationTime = this.$cookies.get('nextrequest_session_expires')
      const now = new Date()
      expirationTime = new Date(expirationTime)
      const differenceTime = new Date(
        Math.abs(now.getTime() - expirationTime.getTime())
      )
      const minutes = differenceTime.getMinutes()
      const seconds = differenceTime.getSeconds()
      return { minutes, seconds }
    },
    setUpSessionExpiration() {
      const sessionCookiePresent = () =>
        this.$cookies?.isKey('nextrequest_session_expires')

      // If the cookie is not set then the session has no expiration, and so we do not need to check for it.
      if (sessionCookiePresent()) {
        const sessionExpirationInterval = setInterval(() => {
          if (this.user && !sessionCookiePresent()) {
            this.sessionExpired = true
            this.showSessionWarningModal = false
            this.setCsrfTokenFromApi()
            localStorage.clear()
            clearInterval(sessionExpirationInterval)
          } else if (this.user && sessionCookiePresent()) {
            const time = this.timeToSessionExpiration()
            if (time.minutes < 2) {
              const formatSeconds = time.seconds.toString().padStart(2, '0')
              this.expirationInMinsAndSecs = `${time.minutes} min ${formatSeconds} sec`
              this.showSessionWarningModal = true
            } else {
              this.showSessionWarningModal = false
            }
          }
        }, 1000)
      }
    },
    directToSignIn() {
      if (this.hasCivicplusSSOFeature) {
        this.$refs.signInForm.requestSubmit()
      } else {
        window.location.href = '/users/sign_in'
      }
    },
    handleNavigate(event, routerNavFunc) {
      if (this.isSpa) {
        return routerNavFunc(event)
      }
    },
    getNavbarItemClassName(path) {
      const isActive = window.location.pathname === path.path
      return ['navbar-item', { 'navbar-item--active': isActive }]
    },
    ...mapMutations(['setAbility']),
    submitPermission(): void {
      if (this.isRapidReview && this.selectedPreviewUsers.role === 'guest') {
        this.$toasted.error(
          'The user you have selected does not have access to this page'
        )
        return
      }
      API.setPermissionUserPreview({
        user_id: this.selectedPreviewUserId
      }).then((_response) => {
        window.location.reload()
      })
    },
    setPermissionModal(): void {
      this.permissionModal = true
    },
    searchPreviewUsers: throttle(function (searchText = '') {
      this.fetchPreviewUsers(searchText)
    }, 400),

    setPreviewUsers(staff: object): void {
      this.selectedPreviewUsers = staff
    },
    fetchPreviewUsers(searchText: string = ''): void {
      const newFetchState = { ...this.previewFetchState }
      if (
        this.previewFetchState.search_text === searchText && // eslint-disable-line camelcase
        this.previewFetchState.end
      ) {
        return
      }
      if (this.previewFetchState.search_text === searchText) {
        Object.assign(newFetchState, {
          search_text: searchText,
          page: this.previewFetchState.page + 1,
          fetching: true
        })
      }
      // eslint-disable-next-line camelcase
      if (this.previewFetchState.search_text !== searchText) {
        Object.assign(newFetchState, {
          search_text: searchText,
          page: 1,
          end: false,
          fetching: true
        })
      }
      const payload = {
        search_text: searchText,
        page_number: newFetchState.page,
        request_pretty_id: this.requestPrettyId
      }
      API.fetchPreviewUsers(payload)
        .then((response) => {
          const res = response.data
          let staffList = []
          if (res.length) {
            staffList = res.map((usr) => {
              return {
                value: usr.id,
                label: usr.name_with_email,
                role: usr.role
              }
            })
          }
          if (this.previewFetchState.search_text !== payload.search_text) {
            this.filteredPreviewUsers = []
            this.filteredPreviewUsers = staffList.concat(genericUsers)
          } else {
            this.filteredPreviewUsers = uniqBy(
              [...this.filteredPreviewUsers, ...staffList, ...genericUsers],
              'value'
            )
          }
          this.previewFetchState = Object.assign(newFetchState, {
            end: staffList.length < 25,
            fetching: false
          })
        })
        .catch(() => {
          this.filteredPreviewUsers = [].concat(genericUsers)
          this.previewFetchState = Object.assign(newFetchState, {
            fetching: false
          })
        })
    },
    loadMorePreviewUsers: throttle(function () {
      this.fetchPreviewUsers(this.previewFetchState.search_text)
    }, 400),

    resetPreviewModal() {
      this.filteredPreviewUsers = []
      this.permissionModal = false
      this.previewFetchState = {
        page: 0,
        search_text: '',
        end: false,
        fetching: false
      }
    },

    handleToggleMenu(): void {
      this.isMenuToggled = !this.isMenuToggled

      if (this.isMenuToggled) {
        this.$refs.menu.classList.add('is-active')
      } else {
        this.$refs.menu.classList.remove('is-active')
      }
    },

    handleSignoutClick(): void {
      this.$emit('on-sign-out')
    },

    focusMainContent() {
      const main = document.getElementById('skip-to-main-content')
      if (main) {
        main.setAttribute('tabindex', '-1')
        main.focus()
      }
    }
  }
})
</script>

<style lang="scss">
.permission-modal {
  .nr-modal__content {
    padding: 1.25em;
  }
  .label {
    color: #09090b;
    display: block;
    font-size: 1rem;
    font-weight: 700;
    background-color: white;
    border: none;
    float: left;
    padding: 0 0 8px 0;
  }
}

.session-warning-modal.nr-modal {
  z-index: 9999;
  position: fixed;
}
.redaction-hover {
  z-index: 1;
}
</style>

<style scoped lang="scss">
@import '../../../styles/globals.scss';
$navbar-breakpoint: $tablet;
@import 'bulma/bulma.sass';
@import '@nextrequestco/components/src/styles/tokens/tokens.scss';

.button.is-primary {
  background-color: $color-blue-100;
  margin-bottom: 0;
  top: 0;

  &:focus:not(:active) {
    outline: 2px dotted #10163e;
    outline-offset: 4px;
  }
}

.navbar {
  flex-wrap: wrap;
}

.inline-icon {
  display: inline-block;
  vertical-align: middle;
}

.navbar {
  box-shadow: 0 1px 3px 0px rgba(56, 56, 56, 0.16);
}

.navbar,
.navbar-menu {
  background-color: $color-white !important;
  ul {
    display: flex;
    li {
      margin-top: $spacing-16;
    }
  }
}

.navbar-container {
  .navbar-brand {
    flex-shrink: 1;
    padding: $spacing-8 $spacing-24 $spacing-8 $spacing-24;
    background-color: $color-gray-20;
  }
}

a.navbar-item:hover,
.navbar-item:hover,
a.navbar-item:focus,
.navbar-item:focus,
a.navbar-item:active,
.navbar-item:active,
.navbar-item.has-dropdown:active .navbar-link,
.navbar-item.has-dropdown:active a.navbar-link,
.navbar-item.has-dropdown:hover .navbar-link,
.navbar-item.has-dropdown:hover a.navbar-link,
.navbar-item.has-dropdown:focus .navbar-link,
.navbar-item.has-dropdown:focus a.navbar-link {
  background-color: transparent;
}
.navbar-dropdown .navbar-item::after {
  display: none;
}

.navbar-item {
  .navbar-link:hover,
  a:hover {
    color: inherit;
  }
}

.navbar-item {
  &.navbar-title {
    font-size: $font-size-5;
    font-family: 'Inter', 'Open Sans', Arial, sans-serif;
    font-weight: 300;
    letter-spacing: -1px;
    line-height: 100%;
    padding: 4px 0 8px;
  }
  &.navbar-title:hover,
  .navbar-title:focus,
  .navbar-title:active {
    color: $color-blue-110;
  }
}

.navbar-start .navbar-item {
  &.navbar-item--active {
    a {
      border-bottom-color: currentColor;
    }
  }
  a {
    border-bottom: 2px solid transparent;
    &:hover {
      border-color: currentColor;
    }
  }
}

.navbar-menu {
  font-size: 0.875rem;
}

.navbar-dropdown {
  .navbar-item {
    text-transform: none;
  }
}

@media screen and (max-width: 769px) {
  .navbar-container {
    display: block;
    flex-grow: unset;
  }
}

@media screen and (min-width: 769px) {
  .navbar-container {
    display: flex;
    flex-grow: 1;
  }
}

@media screen and (max-width: 1138px) {
  .navbar-container {
    .search-field-on-navbar {
      display: none;
    }
  }
}

.openid-form {
  display: none;
}

.preview-banner {
  background: $yellow;
  display: flex;
  justify-content: space-between;
  padding: 0.5em;

  display: flex;
  flex-direction: row;
  align-items: center;

  &-title {
    font-size: 20px;
  }
  &-switch-container {
    text-align: right;
    position: relative;
    .icon {
      transform: scale(0.6) translate(0px, 10px);
    }
    .switch {
      position: relative;
    }
  }

  @media screen and (max-width: 800px) {
    & {
      flex-wrap: wrap;

      & > * {
        text-align: center;
      }

      &-spacer {
        display: none;
      }
    }
  }
}

#name-and-badge-png {
  height: 1rem;
}
</style>
